// extracted by mini-css-extract-plugin
export default {"Table":"Teams-module__Table__OP3Cx"};